import { DateTime } from 'luxon';

export default (date: string, format: string) => {
  return DateTime.fromISO(date).toFormat(format);
};
